export const menu_data = [
  { id: 1, name: "Alimentos", slug: "alimentos", url: "/categorias/alimentos" },
  { id: 2, name: "Apple", slug: "apple", url: "/categorias/apple" },
  {
    id: 3,
    name: "Ar e Ventilação",
    slug: "ar-e-ventilacao",
    url: "/categorias/ar-e-ventilacao",
  },
  { id: 4, name: "Áudio", slug: "audio", url: "/categorias/audio" },
  { id: 5, name: "Bebê", slug: "bebe", url: "/categorias/bebe" },
  { id: 6, name: "Bebidas", slug: "bebidas", url: "/categorias/bebidas" },
  {
    id: 7,
    name: "Beleza e Saúde",
    slug: "beleza-e-saude",
    url: "/categorias/beleza-e-saude",
  },
  {
    id: 8,
    name: "Brinquedos e Colecionáveis",
    slug: "brinquedos-e-colecionaveis",
    url: "/categorias/brinquedos-e-colecionaveis",
  },
  {
    id: 9,
    name: "Cama, Mesa & Banho",
    slug: "cama-mesa-banho",
    url: "/categorias/cama-mesa-banho",
  },
  {
    id: 10,
    name: "Eletrodomésticos",
    slug: "eletrodomesticos",
    url: "/categorias/eletrodomesticos",
  },
  {
    id: 11,
    name: "Eletroportáteis",
    slug: "eletroportateis",
    url: "/categorias/eletroportateis",
  },
  {
    id: 12,
    name: "Esportes | Mobilidade",
    slug: "esportes-mobilidade",
    url: "/categorias/esportes-mobilidade",
  },
  {
    id: 13,
    name: "Ferramentas e Jardim",
    slug: "ferramentas-e-jardim",
    url: "/categorias/ferramentas-e-jardim",
  },
  { id: 14, name: "Games", slug: "games", url: "/categorias/games" },
  {
    id: 15,
    name: "Informática",
    slug: "informatica",
    url: "/categorias/informatica",
  },
  {
    id: 16,
    name: "Jardinagem",
    slug: "jardinagem",
    url: "/categorias/jardinagem",
  },
  { id: 17, name: "Mercado", slug: "mercado", url: "/categorias/mercado" },
  { id: 18, name: "Móveis", slug: "moveis", url: "/categorias/moveis" },
  {
    id: 19,
    name: "Smartphones e Tablets",
    slug: "smartphones-e-tablets",
    url: "/categorias/smartphones-e-tablets",
  },
  { id: 20, name: "Sono", slug: "sono", url: "/categorias/sono" },
  { id: 21, name: "Starlink", slug: "starlink", url: "/categorias/starlink" },
  {
    id: 22,
    name: "Sua Casa Inteligente",
    slug: "sua-casa-inteligente",
    url: "/categorias/sua-casa-inteligente",
  },
  { id: 23, name: "Trade In", slug: "trade-in", url: "/categorias/trade-in" },
  {
    id: 24,
    name: "Utensílios Domésticos",
    slug: "utensilios-domesticos",
    url: "/categorias/utensilios-domesticos",
  },
  {
    id: 25,
    name: "Vestuário e Equipamentos",
    slug: "vestuario-e-equipamentos",
    url: "/categorias/vestuario-e-equipamentos",
  },
  { id: 26, name: "Vídeo", slug: "video", url: "/categorias/video" },
]

export default menu_data
